@if (control().value && control().enabled) {
    <button (click)="clear()" [attr.aria-label]="label()" mat-icon-button type="button">
        <mat-icon>close</mat-icon>
    </button>
}
